import { configureStore, Action, getDefaultMiddleware } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'
import localStorage from 'redux-persist/lib/storage'
import { persistReducer, PersistConfig, PersistedState } from 'redux-persist'

import { rootReducer, AppState } from './reducer'
import { INITIAL_STATE as BOOKING_SLICE_INITIAL_STATE } from './booking/slice'

export const PERSIST_KEY = 'root'

const persistConfig: PersistConfig<AppState> = {
  key: PERSIST_KEY,
  version: 1,
  storage: localStorage,
  whitelist: ['booking'],
  migrate: state => {
    // TODO: try to simply all these stupid TS hacks.
    // So far the lib itself seems not very good in terms of TS and brings more issues than help
    if (state) {
      const persistedState = (state as unknown) as AppState
      const migratedState = ({
        ...persistedState,
        booking: {
          ...persistedState?.booking,
          abTestsData: persistedState?.booking.abTestsData || BOOKING_SLICE_INITIAL_STATE.abTestsData
        }
      } as unknown) as PersistedState
      return Promise.resolve(migratedState)
    } else {
      return Promise.resolve(state)
    }
  }
}

export const createStore = (initialState?: AppState) => {
  const store = configureStore({
    reducer: persistReducer(persistConfig, rootReducer),
    preloadedState: initialState,
    middleware: getDefaultMiddleware({
      serializableCheck: false
    })
  })

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducer', () => {
      const { reducer } = require('./reducer')
      store.replaceReducer(reducer)
    })
  }

  return store
}

const store = createStore()

export type AppThunk = ThunkAction<unknown, AppState, undefined, Action>
export type AppDispatch = typeof store.dispatch
